import { Controller } from 'stimulus'

/**
 * Adds or removes a CSS class on the base controller DOM element
 *
 * Arguments
 *
 * * add-remove-css-class - CSS class to add/remove
 *
 *
 * @class AddRemoveCssController
 * @memberof Controllers
 * @example
 * -# Example Markup (HAML)
 *
 * -# 'Global' Event Triggered
 *
 * %span{ data: { controller: 'add-remove-css', 'action': 'item:add@document->add-remove-css#add', 'add-remove-css-class': 'span--hidden' }}
 *   Hides when document receives 'item:add' event
 *
 *
 * -# Self-triggering
 *
 * .notice{ data: { controller: 'add-remove-css', 'add-remove-css-class': 'notice--hidden' }}
 *   %span Just so you know, some stuff has occurred
 *   %button{ 'data-action': 'add-remove-css#add' } Got it
 */
export default class extends Controller {
  /**
   * @function Controllers.AddRemoveCssController.remove
   * @memberof Controllers
   * @description Removes css class
   * @param {Event} event - DOM event
   */
  remove(event) {
    this.element.classList.remove(this.cssClass)
  }

  /**
   * @function Controllers.AddRemoveCssController.add
   * @memberof Controllers
   * @description Adds css class
   * @param {Event} event - DOM event
   */
  add(event) {
    this.element.classList.add(this.cssClass)
  }

  /**
   * @function Controllers.AddRemoveCssController.cssClass
   * @memberof Controllers
   * @description Retrieves CSS class to add/remove
   * @return {String} CSS class
   */
  get cssClass() {
    return this.data.get('class')
  }
}
